export default {
  header: [
    {
      cta: [],
      heading: 'We want you.',
      spacing: '',
      component: 'm-section-header-v2',
      heading_size: '',
    },
  ],
  copy_no_results: 'No jobs found. Check back later!',
  component: 'o-job-list',
}
